import { FACEBOOK_CLICK_ID_REGEX } from '../constants';

export const getFacebookClickIdFromCookie = (): string | undefined => {
  const result = document.cookie.match(FACEBOOK_CLICK_ID_REGEX);

  if (result) {
    return result[1];
  }
};
